import React from "react";
import { useLocation } from "@reach/router";

interface SEOProps {
  title?: string;
  description?: string;
  children?: React.ReactNode;
  featuredImage?: string;
  content?: string;
  defaultTitle?: string;
  defaultDescription?: string;
}

export const SEO = ({
  title,
  description,
  children,
  featuredImage,
  content,
  defaultTitle = "Vellis", // Default site name
  defaultDescription = "", // Default description
}: SEOProps) => {
  const location = useLocation();
  const pathname = location.pathname + location.search;
  const siteUrl = "https://www.vellis.financial";
  const separator = " | ";

  const generateTitle = (pageTitle?: string) => {
    return pageTitle ? `${pageTitle}${separator}${defaultTitle}` : defaultTitle;
  };

  const generateDescription = (desc?: string) => {
    if (desc) return desc;

    if (typeof window !== "undefined" && typeof document !== "undefined") {
      const firstParagraph = document.querySelector("p")?.textContent || "";
      return firstParagraph.slice(0, 156);
    }

    return defaultDescription;
  };

  const seo = {
    title: generateTitle(title),
    description: generateDescription(description),
    url: `${siteUrl}${pathname || ``}`,
    image:
      featuredImage ||
      `https://cms.vellisfinancial.eu/wp-content/uploads/2024/09/ogimage.png`,
    content: content || "website",
  };

  const hreflangs = [{ href: `${siteUrl}${pathname || ``}`, hrefLang: "en" }];

  return (
    <>
      <title>{seo.title}</title>
      <meta
        name="google-site-verification"
        content="DpNs6yzfWc5rK5Jyvd6wn4VXUi2JMnzV4DQ8ZdbIj9A"
      />
      <meta name="description" content={seo.description} />
      <meta property="og:locale" content="en-CA" />
      <meta property="og:site_name" content="Vellis" />
      <meta name="image" content={seo.image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:url" content={seo.url} />
      <meta name="twitter:description" content={seo.description} />
      <meta property="og:description" content={seo.description} />
      <meta name="og:image" content={seo.image} />
      <meta name="og:title" content={seo.title} />
      <meta name="og:url" content={seo.url} />
      <meta name="og:type" content={seo.content} />

      {hreflangs.map((link) => (
        <link
          key={link.hrefLang}
          rel="alternate"
          href={link.href}
          hrefLang={link.hrefLang}
        />
      ))}

      {children}
    </>
  );
};
